"use client";

import LanguageSwitcher from "../LanguageSwitcher";
import styles from "./styles.module.css";
import MenuItem from "@components/atoms/MenuItem";
import config from "config/all-config.json";
import { useTranslations } from "next-intl";
import { usePathname } from "next-intl/client";
import Image from "next/image";
import { NavProps } from "types/Nav.type";

function checkIsActive(pathname: string, key: number, t: any) {
  let isActive = false;
  if (t(`${key}.href`) === "/" && pathname === "/") isActive = true;
  else
    isActive = pathname.includes(t(`${key}.href`)) && t(`${key}.href`) !== "/";
  return isActive;
}
export default function Nav({ expandMenu, setExpandMenu }: NavProps) {
  const pathname = usePathname();
  const t = useTranslations("menu");

  return (
    <nav
      className={`${styles["nav--display"]} ${styles.nav}   ${
        styles["nav--bg-color"]
      } ${expandMenu ? styles["nav--expand"] : ""}`}
    >
      {config.menu.map((item, key) => {
        const isActive = checkIsActive(pathname, key, t);
        return (
          <div key={t(`${key}.title`)}>
            {item.submenu && (
              <div
                className={styles["nav__submenu-container"]}
                key={t(`${key}.title`)}
              >
                <MenuItem
                  title={t(`${key}.title`)}
                  href={t(`${key}.href`)}
                  isActive={isActive}
                  setExpandMenu={setExpandMenu}
                />
                <div className={styles.submenu__wrapper}>
                  <ul className={styles.nav__submenu}>
                    {item.submenu.map((listItem, index) => {
                      const isActiveSubmenu =
                        pathname === t(`${key}.submenu.${index}.href`);
                      return (
                        <li key={t(`${key}.submenu.${index}.title`)}>
                          <MenuItem
                            title={t(`${key}.submenu.${index}.title`)}
                            href={t(`${key}.submenu.${index}.href`)}
                            isActive={isActiveSubmenu}
                            isSubmenu={true}
                            setExpandMenu={setExpandMenu}
                          />
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            )}
            {!item.submenu && (
              <MenuItem
                key={t(`${key}.title`)}
                title={t(`${key}.title`)}
                href={t(`${key}.href`)}
                isActive={isActive}
                setExpandMenu={setExpandMenu}
              />
            )}
          </div>
        );
      })}
      <div className='w-[155px]'>
        <a href="tel:+40765968506" className='flex items-center w-full'>
          <Image src='/call.svg' alt='Phone number' width={16} height={16} className='mr-2' />
          <span>+40 765 968 506</span>
        </a>
        <a href="tel:+40751088733" className='flex items-center w-full'>
          <Image src='/call.svg' alt='Phone number' width={16} height={16} className='mr-2' />
          <span>+40 751 088 733</span>
        </a>
      </div>
      <LanguageSwitcher />
    </nav>
  );
}
